import { JournalId, ParentTeacherConferenceId } from 'types';

export const PARENT_TEACHER_CONFERENCES = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/parent-teacher-conferences`;
export const PARENT_TEACHER_CONFERENCE = (
    journalId: JournalId,
    parentTeacherConferenceId: ParentTeacherConferenceId,
) => `/api/v1/journals/${journalId}/parent-teacher-conferences/${parentTeacherConferenceId}`;
